import { createSignal } from "solid-js";
import { initAuth, currentUser, type AuthUser } from "../lib/auth";
import { api, ApiError } from "../lib/api";

export type OceanUser = {
  id: string;
  org_id: string | null;
  email: string;
  name: string | null;
  role: string;
  avatar_url: string | null;
  created_at: string;
};

const [user, setUser] = createSignal<AuthUser | null>(null);
const [oceanUser, setOceanUser] = createSignal<OceanUser | null>(null);
const [ready, setReady] = createSignal(false);
const [provisionError, setProvisionError] = createSignal<string | null>(null);

export async function bootstrapAuth() {
  try {
    await initAuth();
    const u = currentUser();
    setUser(u);
    if (u) {
      await loadOceanUser();
    }
  } catch (e) {
    setProvisionError(
      e instanceof Error ? `Auth init failed: ${e.message}` : "Auth init failed",
    );
    console.error("[auth] init failed", e);
  } finally {
    setReady(true);
  }
}

async function loadOceanUser() {
  try {
    const me = await api<OceanUser>("/auth/me");
    setOceanUser(me);
    setProvisionError(null);
  } catch (e) {
    if (e instanceof ApiError && e.status === 403) {
      setProvisionError(e.message);
    } else {
      setProvisionError("Failed to load profile");
      console.error("[auth] /auth/me failed", e);
    }
    setOceanUser(null);
  }
}

export function useUser() {
  return user;
}

export function useOceanUser() {
  return oceanUser;
}

export function useAuthReady() {
  return ready;
}

export function useProvisionError() {
  return provisionError;
}
